export const ResponseTypeOptions = [
  {
    value: 'VALID',
    label: 'Valid',
  },
  {
    value: 'INVALID',
    label: 'Invalid',
  },
  {
    value: 'MANUAL_VALID',
    label: 'Valid (Manual Override)',
  },
  {
    value: 'MANUAL_INVALID',
    label: 'Invalid (Manual Override)',
  },
];

export const ManualOverrideOptions = [
  { label: 'Valid (Manual)', value: 'MANUAL_VALID' },
  { label: 'Invalid (Manual)', value: 'MANUAL_INVALID' },
];

export const AutoResponseTypeOptions = [
  { label: 'Valid (Auto)', value: 'VALID' },
  { label: 'Invalid (Auto)', value: 'INVALID' },
];
